import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { getStartedDetails, saveGettingStarted } from "../../../Redux/actions";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import { removeUnderScore } from "../../../helpers";

const schema = yup
  .object({
    i_am_a: yup.string().required(),
    i_am_a_other: yup.string().when("i_am_a", {
      is: "Other",
      then: yup.string().required(),
    }),
    has_works: yup.string().required(),
    has_works_other: yup.string().when("has_works", {
      is: "Other",
      then: yup.string().required(),
    }),
    with: yup.string().required(),
    operates: yup.string().required(),
    interested_in: yup.array().required().min(1),
  })
  .required();
const Welcome = (params) => {
  const initialForm = {
    i_am_a: "",
    i_am_a_other: "",
    has_works: "",
    has_works_other: "",
    with: "",
    operates: "",
    interested_in: [],
  };
  const history = useHistory();
  const dispatch = useDispatch();
  const { setup_wizard_details } = useSelector((state) => state.authReducer);
  useEffect(() => {
    dispatch(getStartedDetails());
  }, []);

  const {
    register,
    formState: { errors },
    handleSubmit,

    control,
  } = useForm({
    defaultValues: initialForm,
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
  });

  const changeInputHandler = (input, val) => {
    setInputForm((prevState) => ({ ...prevState, [input]: val }));
  };

  const checkBoxInputHandler = (event) => {
    if (event.target.checked) {
      if (!inputForm.interested_in.includes(event.target.value)) {
        setInputForm((prevState) => ({
          interested_in: [...prevState.interested_in, event.target.value],
        }));
      }
    } else {
      setInputForm((prevState) => ({
        interested_in: prevState.interested_in.filter(
          (day) => day !== event.target.value
        ),
      }));
    }
  };

  const [inputForm, setInputForm] = useState(initialForm);

  const onFormSubmit = (data) => {
    data.interested_in = data.interested_in.join(",");
    // console.log("sub_data:", data);
    dispatch(saveGettingStarted(data));
  };

  return (
    <UserInterface noNav={true}>
      {console.log("inputForm::::", inputForm)}
      <div className="welcome-experience">
        <div className="top-sec">
          <img className="logo-img" src="/img/gogmgo_wizard_logo.svg" />
        </div>

        <div className="middle-sec">
          <form
            // action="{{ route('get_started') }}"
            className=""
            id="MerchantInfoGetStartedForm"
            method="post"
            accept-charset="utf-8"
            onSubmit={handleSubmit(onFormSubmit)}
          >
            <div className="shadowclass span5">
              <h4> Let’s create the best experience for you </h4>
              <p> Tell us a little bit about yourself </p>
              <div className="declaration">
                <p>
                  I am a
                  <select
                    {...register("i_am_a")}
                    name="i_am_a"
                    className="dropdown required others select-class no-val"
                    // ref="i_am_a"
                    id="i_am_a"
                    value={inputForm?.i_am_a}
                    onChange={(e) => {
                      changeInputHandler("i_am_a", e?.target?.value);
                    }}
                  >
                    <option value="">Select</option>
                    {setup_wizard_details?.i_am_a &&
                      Object.keys(setup_wizard_details?.i_am_a).map(
                        (option) => {
                          return <option value={option}> {option}</option>;
                        }
                      )}
                  </select>
                  {inputForm?.i_am_a == "Other" && (
                    <input
                      name="i_am_a_other"
                      {...register("i_am_a_other")}
                      className="other-options"
                      id="i_am_a_other"
                      type="text"
                      value={inputForm?.i_am_a_other}
                      onChange={(e) => {
                        changeInputHandler("i_am_a_other", e?.target?.value);
                      }}
                    />
                  )}
                  {errors?.i_am_a && (
                    <label className="error">
                      {removeUnderScore(errors.i_am_a?.message)}
                    </label>
                  )}
                  {errors?.i_am_a_other && (
                    <label className="error">
                      {removeUnderScore(errors.i_am_a_other?.message)}
                    </label>
                  )}
                  that has/works for a
                  <select
                    name="has_works"
                    {...register("has_works")}
                    className="dropdown required others select-class no-val"
                    // ref="has_works"
                    id="has_works"
                    value={inputForm?.has_works}
                    onChange={(e) => {
                      changeInputHandler("has_works", e?.target?.value);
                    }}
                  >
                    <option value="">Select</option>
                    {setup_wizard_details?.has_works &&
                      Object.keys(setup_wizard_details?.has_works).map(
                        (option) => {
                          return <option value={option}> {option}</option>;
                        }
                      )}
                  </select>
                  {inputForm?.has_works == "Other" && (
                    <input
                      name="has_works_other"
                      {...register("has_works_other")}
                      className="other-options"
                      id="has_works_other"
                      type="text"
                      value={inputForm?.has_works_other}
                      onChange={(e) => {
                        changeInputHandler("has_works_other", e?.target?.value);
                      }}
                    />
                  )}
                  {errors?.has_works && (
                    <label className="error">
                      {removeUnderScore(errors.has_works?.message)}
                    </label>
                  )}
                  {errors?.has_works_other && (
                    <label className="error">
                      {removeUnderScore(errors.has_works_other?.message)}
                    </label>
                  )}
                  with
                  <select
                    name="with"
                    {...register("with")}
                    className="dropdown required select-class no-val"
                    id="MerchantInfoWith"
                    value={inputForm?.with}
                    onChange={(e) => {
                      changeInputHandler("with", e?.target?.value);
                    }}
                  >
                    <option value="">Select</option>
                    {setup_wizard_details?.with &&
                      Object.keys(setup_wizard_details?.with).map((option) => {
                        return <option value={option}> {option}</option>;
                      })}
                  </select>
                  {errors?.with && (
                    <label className="error">
                      {removeUnderScore(errors.with?.message)}
                    </label>
                  )}
                  that operates (a)
                  <select
                    {...register("operates")}
                    name="operates"
                    className="dropdown required select-class no-val"
                    id="MerchantInfoOperates"
                    value={inputForm?.operates}
                    onChange={(e) => {
                      changeInputHandler("operates", e?.target?.value);
                    }}
                  >
                    <option value="">Select</option>
                    {setup_wizard_details?.operates &&
                      Object.keys(setup_wizard_details?.operates).map(
                        (option) => {
                          return <option value={option}> {option}</option>;
                        }
                      )}
                  </select>
                  {errors?.operates && (
                    <label className="error">
                      {removeUnderScore(errors.operates?.message)}
                    </label>
                  )}
                </p>
              </div>
              <div className="companies_services">
                <p> The services my company is interested in are:</p>
                <div className="checkBoxes options-sec">
                  {setup_wizard_details?.operates &&
                    Object.keys(setup_wizard_details?.interested_in).map(
                      (index) => {
                        return (
                          <div className="checkbox avaiCheck">
                            <input
                              type="checkbox"
                              {...register("interested_in")}
                              className="avail_checkbox"
                              value={index}
                              id={`id${index}`}
                              onClick={(e) => {
                                checkBoxInputHandler(e);
                              }}
                            />
                            <label for={`id${index}`}>
                              {setup_wizard_details?.interested_in?.[index]}
                            </label>
                          </div>
                        );
                      }
                    )}
                  {errors?.interested_in && (
                    <label className="error">
                      {removeUnderScore(errors.interested_in?.message)}
                    </label>
                  )}
                </div>
              </div>

              <div className="mt-3 d-flex justify-content-end">
                <button
                  className="btn btn_btnblue"
                  type="submit"
                  name="next"
                  id="next"
                >
                  Next Step
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </UserInterface>
  );
};
export default Welcome;
